import { create } from 'zustand'
import { useEventStore } from './eventStore'
import IDB from '../../utils/indexedDb'
import { getGetter } from '../reactStore/vuexBridge'
import Vue from 'vue'

export const useHomeProductStore = create((set, get) => ({
  products: [],
  page: 1,
  hasMore: true,
  isLoading: false,
  catIds: [],
  catInfo: [],
  url: process.env.APP_URL,
  preventRegularCall: false,

  fetchProducts: async (pageParam = 1, isCache = false) => {
    const { hasMore, isLoading, catIds, products, preventRegularCall } = get()
    if (!hasMore || isLoading || preventRegularCall) return

    if (isCache) {
      const cache = await IDB.get('homeListingCache')
      set((state) => ({
        products: cache.products,
        page: cache.page,
        hasMore: cache.hasMore, // stop when last page
        isLoading: false
      }))
      return
    }

    set({ isLoading: true })

    const query = `{
      listing(
          page: ${pageParam},
          size: 24,
          isKids: false,
          isWeb: true,
          category: ${JSON.stringify(catIds || [])},
          sort: POPULARITY,
          artist: [],
          tags: [],
          filters: { price: [] },
      ){
        products{
          id
          product
          artist{name,slug}
          category{name}
          price
          genderType
          stock
          avgRating
          ratingCount
          prodQty
          prodType
          splPrice
          exclusivePrice
          sortOrder
          images
          extraPrice
          product_slug: productSlug
        }
        pagination {
          currentPage
          totalPages
          totalProduct
        }
      }
    }`

    if (catIds?.length) {
      try {
        const res = await fetch(`${process.env.APP_URL}graphql`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ query })
        })

        const data = await res.json()
        const newProducts = data.data.listing.products
        const pagination = data.data.listing.pagination

        set((state) => ({
          products: [...state.products, ...newProducts],
          page: pagination.currentPage,
          hasMore: pagination.currentPage < pagination.totalPages, // ✅ stop when last page
          isLoading: false
        }))
        let cacheData = {products: [...products, ...newProducts], page: pagination.currentPage, hasMore: pagination.currentPage < pagination.totalPages, isLoading: false, webcategory: getGetter('webcategory'), catIds}
        IDB.set('homeListingCache', cacheData).then(() => {
          set({ preventRegularCall: false })
        })

        // event tracking
        const { GTM_EVENT, GTAG_EVENT, MOENGAGE_EVENT } = useEventStore.getState()
        const payload = {
          items: newProducts.map(obj => {
            return {
              Product_id: obj?.id || 'NA',
              Product_name: obj?.product || 'NA',
              Product_slug: obj?.product_slug || 'NA',
              Product_type: obj?.prodType || 'NA'
            }
          }),
          page: pagination.currentPage,
          categories: catIds.join(',') || 'NA'
        }
        GTM_EVENT({ eventName: 'iscroll_view_item_list', payload })
        GTAG_EVENT({ eventName: 'iscroll_view_item_list', payload })
        MOENGAGE_EVENT({ eventName: 'iscroll_view_item_list', payload })
      } catch (error) {
        console.error('Error fetching products:', error)
        set({ isLoading: false })
      }
    }
  },

  fetchCategoryInfo: async (category) => {
    const { catInfo } = get()
    try {
      let lastWidgetId = Vue.ls.get('lastWidgetId') || null
      if (lastWidgetId && lastWidgetId.path && lastWidgetId.path === window.location.pathname && catInfo && catInfo.length > 0) return
      const res = await fetch(`${process.env.APP_URL}categories-info?ids=${category}`, {
        method: 'GET'
      })
      lastWidgetId.path = window.location.pathname
      Vue.ls.set('lastWidgetId', lastWidgetId)
      set({ catInfo: await res.json() })
    } catch (error) {
      console.log('Error fetching category info:', error)
    }
  },

  getCatList: (ids) => {
    set({ catIds: ids })
  },

  clearProducts: () => set({ products: [], page: 1, hasMore: true, isLoading: false })
}))



// WEBPACK FOOTER //
// ./src/react-component/reactStore/homeProduct.js